export interface IStyleOptions {
  rtl?: boolean;
  specificityMultiplier?: number;
}
